import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 521 522"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#E25439",
      "fill-rule": "nonzero",
      d: "M377.35 339.44a140.94 140.94 0 0 1-232.81 1.16l255.37-59 41.59-9.6 79.5-18.32a262.4 262.4 0 0 0-6.62-51.74C482 61.74 342.14-25.68 201.94 6.69S-25.68 179 6.68 319.16 179 546.78 319.15 514.41c79.508-18.276 145.828-72.81 179.12-147.29zM228.84 123.2c55.936-12.9 114.108 9.397 147.09 56.38l-254.58 58.78c9.046-56.69 51.558-102.234 107.49-115.16"
    }, null, -1)
  ])))
}
export default { render: render }